import React from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMRadioButton from "src/components/UI/atoms/ATMRadioButton/ATMRadioButton";
import { useOutletContext } from "react-router-dom";

const GenderOption = [
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];
const MaritalStatusOption = [
  {
    label: "Single",
    value: "SINGLE",
  },
  {
    label: "Married",
    value: "MARRIED",
  },
  {
    label: "Separate",
    value: "SEPARATE",
  },
];

const StudentPersonalInformation = () => {

  const [{ formikProps }]: any = useOutletContext()
  const { values, setFieldValue, isSubmitting } = formikProps;

  return (
    <div >
      <div className="grid xl:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 xl:gap-6 gap-4">
        <div>
          <ATMDatePicker 
           views={['day' , 'month','year']}
            name="dob"
            value={values?.dob || null}
            onChange={(newValue) => setFieldValue("dob", newValue)}
            label="Date Of Birth"
          />
        </div>

      </div>
      <div className=" grid xl:grid-cols-3 grid-cols-1">
        <div className="mt-3">
          <ATMRadioButton
            label="Gender"
            name="gender"
            value={values?.gender || ""}
            className="mt-1  flex"
            options={GenderOption}
            onChange={(e) => {
              setFieldValue("gender", e);
            }}
          />
        </div>
        <div className="mt-3">
          <ATMRadioButton
            label="Marital Status"
            name="marital_status"
            value={values?.marital_status || ""}
            className="mt-1  flex"
            options={MaritalStatusOption}
            onChange={(e) => {
              setFieldValue("marital_status", e);
            }}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <ATMLoadingButton
          className="flex justify-end w-[90px] px-8"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StudentPersonalInformation;
